const SITE_HOST = process.env.VUE_APP_SITE_HOST;

export const AUTH_CONFIG = {
  clientId: "vDfG8Wfh1nlNSrcnqRdzw8Tm8H2WKwL5",
  domain: "pie-api.auth0.com",
  callbackUrl: `${SITE_HOST}/callback/`,
  audience: "pie-api"
};
